import { ComponentPropsWithoutRef, forwardRef, useEffect, useId, useRef } from 'react';

import { Choice, ChoiceProps } from '../Choice/Choice';
import { StyledCheckbox } from './Checkbox.styles';

export interface Props extends Omit<ComponentPropsWithoutRef<'input'>, 'id'>, ChoiceProps {
	indeterminate?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, Props>(
	({ disabled = false, error, helpText, id, label, labelHidden, onChange, indeterminate = false, ...rest }, ref) => {
		const generatedId = useId();

		const internalRef = useRef<HTMLInputElement | null>(null);

		useEffect(() => {
			if (!internalRef.current) return;

			internalRef.current.indeterminate = indeterminate;
		}, [ref, indeterminate]);

		return (
			<Choice
				disabled={disabled}
				error={error}
				helpText={helpText}
				id={id ?? generatedId}
				label={label}
				labelHidden={labelHidden}
			>
				<StyledCheckbox
					{...rest}
					disabled={disabled}
					id={id ?? generatedId}
					onChange={onChange}
					ref={(node) => {
						if (typeof ref === 'function') {
							ref(node);
						} else if (ref) {
							ref.current = node;
						}
						internalRef.current = node;
					}}
					type="checkbox"
				/>
			</Choice>
		);
	}
);
Checkbox.displayName = 'Checkbox';
